import VueRouter from 'vue-router';
import store from '@js/store';
import permission from '@js/libs/permissions';

const abortNavigationIfNotPermitted = (permission, next) => {
    const hasPermisson = store.getters['Auth/hasPermissionTo'];
    const isSuperAdmin = store.getters['Auth/hasSuperAdminRole'];

    if (hasPermisson(permission) || isSuperAdmin) {
        next();
        return;
    }

    next(false);
};

const routeComponents = {
    product: [
        {
            path: '/',
            component: require('./components/product/product-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_PRODUCT, next);
            },
        },
        {
            path: '/:id',
            component: require('./components/product/product-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_PRODUCT, next);
            },
        },
    ],

    stockCheck: [
        {
            path: '/',
            component: require('./components/stock_check/stock-check-index.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_CHECK,
                    next,
                );
            },
        },
        {
            path: '/create',
            component: require('./components/stock_check/stock-check-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.SAVE_STOCK_CHECK,
                    next,
                );
            },
        },
        {
            path: '/:id',
            component: require('./components/stock_check/stock-check-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_CHECK,
                    next,
                );
            },
        },
    ],

    stockReturn: [
        {
            path: '/',
            component: require('./components/stock_return/stock-return-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_RETURN,
                    next,
                );
            },
        },
        {
            path: '/create',
            component: require('./components/stock_return/stock-return-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.SAVE_STOCK_RETURN,
                    next,
                );
            },
        },
        {
            path: '/:id',
            component: require('./components/stock_return/stock-return-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_RETURN,
                    next,
                );
            },
        },
    ],

    stockReceive: [
        {
            path: '/',
            component: require('./components/stock_receive/stock-receive-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_RECEIVE,
                    next,
                );
            },
        },
        {
            path: '/create',
            component: require('./components/stock_receive/stock-receive-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.SAVE_STOCK_RECEIVE,
                    next,
                );
            },
        },
        {
            path: '/:id',
            component: require('./components/stock_receive/stock-receive-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_RECEIVE,
                    next,
                );
            },
        },
    ],
    stockRequest: [
        {
            path: '/',
            component: require('./components/stock_request/stock-request-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_REQUEST,
                    next,
                );
            },
        },
        {
            path: '/create',
            component: require('./components/stock_request/stock-request-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.SAVE_STOCK_REQUEST,
                    next,
                );
            },
        },
        {
            path: '/:id',
            component: require('./components/stock_request/stock-request-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_STOCK_REQUEST,
                    next,
                );
            },
        },
    ],
    purchaseOrder: [
        {
            path: '/',
            component: require('./components/purchase-order/purchase-order-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_PURCHASE_ORDER,
                    next,
                );
            },
        },
        {
            path: '/create',
            component: require('./components/purchase-order/purchase-order-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.SAVE_PURCHASE_ORDER,
                    next,
                );
            },
        },
        {
            path: '/:id',
            component: require('./components/purchase-order/purchase-order-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_PURCHASE_ORDER,
                    next,
                );
            },
        },
    ],
    rolePermission: [
        {
            path: '/',
            component: require('./components/role_permissions/role-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_ROLES, next);
            },
        },
        {
            path: '/:id',
            component: require('./components/role_permissions/role-permissions.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_ROLES, next);
            },
        },
    ],
    tag: [
        {
            path: '/',
            component: require('./components/settings/tag/tag-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_TAG, next);
            },
        },
        {
            path: '/create',
            component: require('./components/settings/tag/tag-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_TAG, next);
            },
        },
        {
            path: '/:id',
            component: require('./components/settings/tag/tag-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_TAG, next);
            },
        },
    ],

    integration: [
        {
            path: '/',
            component: require('./components/settings/integration/integration-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(
                    permission.VIEW_INTEGRATION,
                    next,
                );
            },
        },
    ],

    userManagement: [
        {
            path: '/',
            component: require('./components/user/user-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_USER, next);
            },
        },
        {
            path: '/create',
            component: require('./components/user/user-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_USER, next);
            },
        },
        {
            path: '/:id',
            component: require('./components/user/user-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_USER, next);
            },
        },
    ],

    supplier: [
        {
            path: '/',
            component: require('./components/supplier/supplier-list.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.VIEW_SUPPLIER, next);
            },
        },
        {
            path: '/create',
            component: require('./components/supplier/supplier-create.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_SUPPLIER, next);
            },
        },
        {
            path: '/:id',
            component: require('./components/supplier/supplier-edit.vue'),
            beforeEnter: (to, from, next) => {
                abortNavigationIfNotPermitted(permission.SAVE_SUPPLIER, next);
            },
        },
    ],
    stocks: [
        {
            path: '/',
            component: require('./components/stock/stock-summary.vue'),
        },
        {
            path: '/import',
            component: require('./components/stock/stock-import.vue'),
        },
        {
            path: '/importprogress/:key/:rows',
            component: require('./components/stock/stock-import-progress.vue'),
        },
    ],
};

module.exports = function(routeKey) {
    const routes = routeComponents[routeKey];
    const router = new VueRouter({
        routes,
    });

    return router;
};



// WEBPACK FOOTER //
// ./resources/assets/js/router.js